import SignInBanner from 'components/Homepage/SignInBanner/SignInBanner';
import withSignInBannerProps from 'viewModel/homepage/signInBanner/withSignInBannerProps';

export default withSignInBannerProps(SignInBanner);
